"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeColors = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var constants_1 = require("./constants");
var clamp = function (number, min, max) {
    return Math.min(Math.max(number, min), max);
};
var clampColorValue = function (value) { return clamp(value, 0, 255); };
var shiftColor = function (color, amount, 
// adding this as a future option, since I have all the logic worked out
method) {
    var colorAsNumber = parseInt(color.slice(1), 16);
    var baseR = colorAsNumber >> 16;
    var baseG = (colorAsNumber >> 8) & 0x00ff;
    var baseB = colorAsNumber & 0x0000ff;
    var operand = method === 'absolute'
        ? function (value) { return value + amount; }
        : function (value) { return value + value * amount; };
    var _a = [baseR, baseG, baseB].map(function (value) {
        return clampColorValue(operand(value));
    }), shiftedR = _a[0], shiftedG = _a[1], shiftedB = _a[2];
    var shiftedHex = (shiftedB | (shiftedG << 8) | (shiftedR << 16))
        .toString(16)
        .padStart(6, '0');
    return "#".concat(shiftedHex);
};
var getPaletteColor = function (palettes, key) {
    var _a = key.split('.'), palette = _a[0], subkey = _a[1];
    return palettes[palette][subkey];
};
var mapSystemPalettes = function (mergedColorTheme, brightnessPalette) {
    var systemEntries = constants_1.UX_COLOR_SYSTEMS.map(function (system) {
        var paletteEntries = constants_1.BASIC_PALETTE_KEYS.map(function (key) {
            return [
                key,
                getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[brightnessPalette][system][key]),
            ];
        });
        return [system, Object.fromEntries(paletteEntries)];
    });
    return Object.fromEntries(systemEntries);
};
var mergeColors = function (baseColors, overrideColors, palette) {
    var _a, _b;
    var brandPrimaryColor = (_b = (_a = overrideColors.brand) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : baseColors.brand.primary;
    var mergedColorTheme = (0, merge_1.default)(baseColors, overrideColors);
    return __assign({ brand: {
            primary: brandPrimaryColor,
            light: shiftColor(brandPrimaryColor, 0.12, 'percentage'),
            dark: shiftColor(brandPrimaryColor, -0.12, 'percentage'),
        }, text: Object.fromEntries(constants_1.TEXT_COLOR_KEYS.map(function (key) { return [
            key,
            getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[palette].text[key]),
        ]; })), background: Object.fromEntries(constants_1.BACKGROUND_COLOR_KEYS.map(function (key) { return [
            key,
            getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[palette].background[key]),
        ]; })) }, mapSystemPalettes(mergedColorTheme, palette));
};
exports.mergeColors = mergeColors;
//# sourceMappingURL=mergeColors.js.map